import { Button, InputOTP, cn } from '@valiant/ui-shared'
import type { MfaViewProps } from './types'
import { useEffect, useRef } from 'react'

export function MfaView({
  className,
  mfaCode,
  setMfaCode,
  onSubmit,
  onPasskeySubmit,
  isLoading,
  passkeysEnabled,
}: MfaViewProps) {
  const isSubmittingRef = useRef(false)

  useEffect(() => {
    if (mfaCode.length === 6 && !isLoading && !isSubmittingRef.current) {
      isSubmittingRef.current = true
      void onSubmit().finally(() => {
        isSubmittingRef.current = false
      })
    }
  }, [mfaCode, onSubmit, isLoading])

  return (
    <div className={cn('flex flex-col h-full p-5', className)}>
      <div className="flex flex-col justify-center h-full">
        <div>
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Multi-Factor Authentication</h2>
          <p className="text-gray-600 mt-8 mb-3 text-xs">
            To confirm please enter authenticator certification code
          </p>
          <div className="flex justify-center mb-8">
            <InputOTP
              value={mfaCode}
              onChange={setMfaCode}
              length={6}
              autoFocus={true}
              disabled={isLoading}
              className="text-center text-2xl font-bold h-[53px] w-[47.5px]"
              name="swap-mfa-code"
              data-testid="swap-mfa-otp-input"
            />
          </div>
          {passkeysEnabled && (
            <Button type="button" disabled={isLoading} onClick={() => void onPasskeySubmit()}>
              Verify with a passkey
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}
